import React from 'react';
import { CubeIcon } from '@fronton/icons-react';
import { DesignRegistrationPanel } from 'common/components';
import { CABINET_ELEMENT_BLOCK } from '../../cabinet-constants';

type CabinetDesignPanelProps = {
  isConsultationFormVisible: boolean;
  signUpHref: string;
}

export const CabinetDesignPanel: React.FC<CabinetDesignPanelProps> = ({ isConsultationFormVisible, signUpHref }) => (
  <DesignRegistrationPanel
    isConsultationFormVisible={isConsultationFormVisible}
    structure={{
      panel: {
        content: {
          leftIcon: CubeIcon,
          iconColor: 'accent-primary',
          iconType: 'duotone',
          text: 'Запишитесь на\u00A0бесплатное проектирование\u00A0\u2014 сделаем дом удобным и\u00A0стильным',
        },
        actionBlock: [
          {
            elementBlock: CABINET_ELEMENT_BLOCK,
            href: signUpHref,
            label: 'Записаться на проектирование',
            target: '_blank',
            variant: 'accent',
          },
        ],
      },
      mobilePanel: {
        content: {
          icon: CubeIcon,
          iconColor: 'accent-primary',
          iconType: 'duotone',
          text: 'Запишитесь на\u00A0бесплатное проектирование\u00A0\u2014 сделаем дом удобным и\u00A0стильным',
        },
        mobileButton: {
          elementBlock: CABINET_ELEMENT_BLOCK,
          openModal: true,
          label: 'Записаться на проектирование',
        },
        actionBlock: [
          {
            elementBlock: CABINET_ELEMENT_BLOCK,
            href: signUpHref,
            label: 'Записаться на проектирование',
            target: '_blank',
            variant: 'accent',
          },
        ],
      },
    }}
  />
)
